import axiosInstance from "../api/axiosInstance";

export const getProducts = async (filters = {}) => {
  console.log("api Filters:", filters);
  const response = await axiosInstance.get("/product/items/filter",{
    params: filters
  });
  console.log("api response:", response.data);
  return response.data;
};

const BASE_URL = "/ecom/filter-keys";

/* GET ALL FILTER SETTINGS */
export const getAllFilterSettings = async (filter) => {
  try {
    console.log(filter,'filtersetting')
    const response = await axiosInstance.get(`${BASE_URL}`,{
      params:filter
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching filter settings:", error);
    throw error;
  }
};



/* CREATE */
export const createFilterSetting = async (data) => {
  try {
    const response = await axiosInstance.post(`${BASE_URL}`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating filter setting:", error);
    throw error;
  }
};


/* UPDATE */
export const updateFilterSetting = async ({ id, data }) => {
  try {
    console.log(data,'payloadData')
    const response = await axiosInstance.put(`${BASE_URL}/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating filter setting:", error);
    throw error;
  }
};


/* DELETE */
export const deleteFilterSetting = async (id) => {
  try {
    console.log(id,'deleteId')
    const response = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting filter setting:", error);
    throw error;
  }
};


export const getItemsList = async () => {
  try {
    const response = await axiosInstance.get('/product/itemNames');
    return response.data;
  }
  catch (err) {
    console.log("error fetching items list", err);
    throw err;
  }
}